import { Dispatch } from '@manigo/manigo-commons';
import { compose } from '@reduxjs/toolkit';
import { connect } from 'react-redux';

import { requestNavigation } from 'store/navigation/actions';

import DefaultRedirection from './DefaultRedirection.layout';
import { DefaultRedirectionDispatchProps } from './DefaultRedirection.types';


const mapDispatchToProps = (dispatch: Dispatch): DefaultRedirectionDispatchProps => ({
    dispatchRequestNavigation: ({ locationPathname, meta }) => dispatch(requestNavigation({ locationPathname, meta })),
    //
});

const decorate = compose(
    connect(null, mapDispatchToProps),
);

export default decorate(DefaultRedirection);
